import { useState } from 'react';

import lessonsData from './lessonsData.json';

export const useLocalData = () => {
  const [lessonValues, setLessonValues] = useState({});

  const loadLessonValues = (activeLesson) => {
    setLessonValues(lessonsData[activeLesson] ?? {});
  };

  const getLessonValues = () => lessonValues;

  const getLessonValue = (prop) => lessonValues[prop] ?? '';

  return { loadLessonValues, getLessonValues, getLessonValue };
};
